import { DisplayElementModel } from '../../../Common/PageBuilder/models/display-element.model';
import { ChartDisplayElementModel } from '../../../Common/Reports/models/chart-display-element.model';
import { ChartStylesModel } from '../../../Common/Charts/models/chart-styles.model';
import { SocialMetricAnalysisTypesEnum } from '../../../Common/Charts/enums/social-analysis-types.enum';
import { ReportSeriesModel } from '@Common/Reports/models/report-series.model';

export class TopTermsListChartDisplayElementModel extends ChartDisplayElementModel implements DisplayElementModel {
    socialSeries: ReportSeriesModel;
    initialLabel: string = '';
    analysisType: SocialMetricAnalysisTypesEnum = SocialMetricAnalysisTypesEnum.volume;

    set series(series: ReportSeriesModel[]) {
        this._series = series;
        this.socialSeries = series[0];

        if (!this._series || !this._series.length) {
            return;
        }

        if (!this.styles) {
            this.styles = new ChartStylesModel();
        }
    }

    get series(): ReportSeriesModel[] {
        return [this.socialSeries];
    }

    constructor(
        title: string,
        series: ReportSeriesModel[],
        initialLabel: string,
        styles?: any,
        analysisType?: SocialMetricAnalysisTypesEnum,
    ) {
        super(title, series, styles);

        this.initialLabel = initialLabel;
        this.analysisType = analysisType ?? SocialMetricAnalysisTypesEnum.volume;

        if (this.styles.checkBoxOptions === undefined) {
            this.styles.checkboxOptions = [];
        }
        // we used to set the default colors here, but now with user prefs, we set them in ChartColorCheckboxesFieldComponent
    }
}
